import { ChangeEvent, KeyboardEvent, MouseEvent, useRef } from "react";
import { searchFormString, searchCodeModalFormString, searchFormDefaultString, searchLabelStyle, } from "src/components/common/common";
import { XButtonForm } from "../XButtonForm";
import { getCategoryByTitle } from "src/configs/categories";

interface Props {
	label: string;
	value: string;
	valueLabel: string;
	handleFoucsId?: string;
	className?: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	onDoubleClick: (e: MouseEvent<HTMLInputElement>) => void;
	onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		codeInputStyle?: string;
		nameTagStyle?: string;
	};
	valueLabelless?: boolean;
}

export const SearchCodeModalForm = ( props: Props ) => {

	const {
		label,
		value,
		valueLabel,
		handleFoucsId,
		className,
		onChange,
		onDoubleClick,
		onKeyDown,
		wrapperOption,
		//  = {
		// 	wrapperStyle: "w-[500px] min-w-[500px] mr-[10px]",
		// 	titleStyle: "w-[50px] min-w-[50px] text-left",
		// 	codeInputStyle: "w-[190px] min-w-[190px]",
		// 	nameTagStyle: "w-[200px] min-w-[200px] text-left",
		// },
		valueLabelless = false,
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);
	const categoryFieldUi = getCategoryByTitle(label)?.searchFieldUi;

	// 우선순위: 화면(wrapperOption) > 카테고리(searchFieldUi) > 컴포넌트 기본값
	const mergedWrapperOption = {
		wrapperStyle: wrapperOption?.wrapperStyle || categoryFieldUi?.wrapperStyle,
		titleStyle: wrapperOption?.titleStyle || categoryFieldUi?.titleStyle,
		codeInputStyle: wrapperOption?.codeInputStyle || categoryFieldUi?.codeInputStyle,
		nameTagStyle: wrapperOption?.nameTagStyle || categoryFieldUi?.nameTagStyle,
	};
	
	return (
		<>
		<div className={`${ searchFormString } ${className} ${mergedWrapperOption.wrapperStyle} cursor-pointer`} 
			// onClick={onDoubleClick}
		>
				<p className={`${searchLabelStyle} ${mergedWrapperOption.titleStyle} cursor-pointer`}>
					{label}
				</p>
				<div className="relative">
				<input className={`${ searchCodeModalFormString } ${mergedWrapperOption.codeInputStyle}`}
					id={handleFoucsId}
					name={handleFoucsId}
					value={value}
					ref={inputRef}
					onClick={(e) => e.stopPropagation()}
					onChange={onChange}
					onDoubleClick={onDoubleClick}
					onKeyDown={onKeyDown} />
					<XButtonForm
						className="right-[2px]"
						onClick={() => {
							if (inputRef.current && onChange) {
								const event = { target: { name: inputRef.current.name, value: '' } } as React.ChangeEvent<HTMLInputElement>;
								onChange(event);
							}
						}}
					/>
				</div>
				{!valueLabelless && (
					<p className={`
						${searchFormDefaultString} bg-gray-disable px-[6px] py-[2px] 
						${mergedWrapperOption.nameTagStyle} h-[24px] text-left flex items-center rounded-[6px]`}
						>
						{valueLabel}
					</p>
				)}
			</div>
		</>
	)
}
